import { useCallback } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { useVirtualBackgroundStore } from '@src/stores';

import { IUploadedImage, TBackgroundEffect } from '@src/types';

interface IProps {
  onSelectBackgroundEffect: (effect: TBackgroundEffect) => void;
}

const useBackgroundEffectsTabs = ({ onSelectBackgroundEffect }: IProps) => {
  const { uploadedBackgrounds, selectedEffect, appendUploadedBackground, removeUploadedBackground } =
    useVirtualBackgroundStore(
      useShallow((state) => ({
        uploadedBackgrounds: state.uploadedBackgrounds,
        selectedEffect: state.selectedEffect,
        appendUploadedBackground: state.appendUploadedBackground,
        removeUploadedBackground: state.removeUploadedBackground,
      }))
    );

  const handleUploadImage = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files[0]) {
        const newImage = URL.createObjectURL(event.target.files[0]);
        appendUploadedBackground({ id: Date.now(), src: newImage });
        onSelectBackgroundEffect({ type: 'image', value: newImage });
      }
    },
    [appendUploadedBackground, onSelectBackgroundEffect]
  );

  const handleRemoveImage = useCallback(
    (image: IUploadedImage) => {
      removeUploadedBackground(image.id);
      if (selectedEffect.value === image.src) {
        onSelectBackgroundEffect({ type: 'none', value: null });
      }
    },
    [onSelectBackgroundEffect, removeUploadedBackground, selectedEffect.value]
  );

  return {
    uploadedBackgrounds,
    selectedEffect,
    handleUploadImage,
    handleRemoveImage,
  };
};

export default useBackgroundEffectsTabs;
